import {
  COMPANY_ADDRESS_LOCALITY,
  COMPANY_ADDRESS_REGION,
  COMPANY_INSTAGRAM_URL,
  COMPANY_LICENSE,
  COMPANY_NAME,
  COMPANY_PHONE_HREF,
  COMPANY_POSTAL_CODE,
  COMPANY_SCHEMA_AREAS_SERVED,
  COMPANY_STREET,
  COMPANY_WEBSITE_URL,
  COMPANY_YELP_URL,
} from "../constants/company";

/** E.164 for schema.org telephone (no tel: prefix) */
const schemaTelephone = COMPANY_PHONE_HREF.replace(/^tel:/i, "");

/**
 * HomeAndConstructionBusiness JSON-LD for Google local / rich results.
 * Injected once into document head from App.js (all routes).
 */
export const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: COMPANY_NAME,
  url: COMPANY_WEBSITE_URL,
  telephone: schemaTelephone,
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY_STREET,
    addressLocality: COMPANY_ADDRESS_LOCALITY,
    addressRegion: COMPANY_ADDRESS_REGION,
    postalCode: COMPANY_POSTAL_CODE,
    addressCountry: "US",
  },
  areaServed: COMPANY_SCHEMA_AREAS_SERVED,
  license: COMPANY_LICENSE,
  sameAs: [COMPANY_INSTAGRAM_URL, COMPANY_YELP_URL],
};
